/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_SalesInputs */

const en_gc_editor_sales = /** @type {(inputs: Gc_Editor_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales dashboard`)
};

const zh_gc_editor_sales = /** @type {(inputs: Gc_Editor_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售数据看板`)
};

/**
* | output |
* | --- |
* | "Sales dashboard" |
*
* @param {Gc_Editor_SalesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_sales = /** @type {((inputs?: Gc_Editor_SalesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_SalesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_sales(inputs)
	return zh_gc_editor_sales(inputs)
});
export { gc_editor_sales as "gc.editor.sales" }